import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDay2026PrimaryThree = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

LaborDay2026PrimaryThree.palette['--sui-palette-background-primary'] = '246 243 239';

export { LaborDay2026PrimaryThree };